<template>
    <label class="flex cursor-pointer">
        <input
            class="absolute sr-only"
            type="checkbox"
            :checked="selected"
            @input="$emit('checked')"
        />

        <div
            class="flex items-center justify-center flex-shrink-0 w-5 h-5 mr-4 text-blue-500 rounded bg-grey-100"
        >
            <span v-if="selected" class="w-3 h-3 rounded-sm bg-color-current"></span>
        </div>

        <div class="text-sm leading-snug text-blue-500">
            {{ label }}
        </div>
    </label>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },

        value: {
            type: String,
            required: true
        },

        selected: {
            type: Boolean,
            default: false
        }
    }
};
</script>
<style scoped>
input:focus + div {
    outline: auto;
    outline: -webkit-focus-ring-color auto 1px;
}
</style>
